<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    
    export let isOpen: boolean = false;
    export let pdfUrl: string = '';
    export let title: string = 'Document Preview';
  
    const dispatch = createEventDispatcher();
  
    const close = () => {
      dispatch('close');
    };
  </script>
  
  {#if isOpen}
    <div class="fixed inset-0 z-[150] flex items-center justify-center p-4 bg-black bg-opacity-70 backdrop-blur-sm">
      
      <div class="bg-white rounded-xl shadow-2xl w-full h-[85vh] max-w-2xl flex flex-col overflow-hidden animate-pop-in relative">
        
        <div class="bg-gray-100 px-4 py-3 border-b border-gray-200 flex justify-between items-center">
          <h3 class="font-semibold text-gray-700">{title}</h3>
          <button 
              on:click={close}
              class="p-1 rounded-full hover:bg-gray-200 text-gray-500 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
  
        <div class="flex-1 bg-gray-50 relative">
          {#if pdfUrl}
              <iframe 
                  src={`https://docs.google.com/viewer?url=${encodeURIComponent(pdfUrl)}&embedded=true`}
                  class="absolute inset-0 w-full h-full border-0"
                  title="PDF Preview"
              ></iframe>
          {:else}
              <div class="flex items-center justify-center h-full text-gray-400">
                  Loading...
              </div>
          {/if}
        </div>
  
      </div>
    </div>
  {/if}
  
  <style>
      .animate-pop-in {
          animation: popIn 0.2s ease-out;
      }
      @keyframes popIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
      }
  </style>